export class Proprietaire {

  nom: string = "";
  prenom: string = "";
  telephone: string = "";
  email: string = "";
  adresse: string = "";

  private errorMessage: string = "";

  constructor() {}

  // Récupérer le message d'erreur
  getErrorMessage(): string {
    return this.errorMessage;
  }

  // Vérifier si on peut sauvegarder
  canSave(): boolean {

    if (!this.nom || this.nom.trim() === "") {
      this.errorMessage = "Veuillez saisir le nom du propriétaire";
      return false;
    }

    if (!this.prenom || this.prenom.trim() === "") {
      this.errorMessage = "Veuillez saisir le prénom du propriétaire";
      return false;
    }

    if (!this.telephone || this.telephone.trim() === "") {
      this.errorMessage = "Veuillez saisir le téléphone du propriétaire";
      return false;
    }

    // Vérification simple du téléphone
    if (this.telephone.length < 8) {
      this.errorMessage = "Le numéro de téléphone est invalide";
      return false;
    }

    // Email optionnel mais valide si rempli
    if (this.email && !this.validateEmail(this.email)) {
      this.errorMessage = "Veuillez saisir un email valide";
      return false;
    }

    if (this.adresse && this.adresse.length > 500) {
      this.errorMessage = "L'adresse est trop longue (500 caractères max)";
      return false;
    }

    this.errorMessage = "";
    return true;
  }

  private validateEmail(email: string): boolean {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }
}